import * as yup from 'yup';

export const schema : any = yup.object().shape({
  name: yup.string().required('This field is required').nullable(),
  email: yup.string().required('This field is required').email('Please, enter a valid email').nullable(),
  company: yup.string().required('This field is required').nullable(),
  phoneNumber: yup.string().required('This field is required').nullable(),
  descriptionRequest: yup.string().required('This field is required').nullable()
});
